export default "__VITE_ASSET__acaffe7a__"